import React from 'react';

import './style.scss';

const Icon = ({ icon, ...props }) => <i className={icon} {...props}></i>;

export default Icon;
